import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { SystemUserModel } from "./SystemUserModel";

export class SystemUserFindResultModel extends BaseFindResult {

    public getDataItem(i: number): SystemUserModel {
        let o: SystemUserModel = Object.assign(new SystemUserModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): SystemUserModel[] {

        let d: SystemUserModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: SystemUserModel = Object.assign(new SystemUserModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
